import { takeEvery, put } from 'redux-saga/effects';
import { updateVisibleTxnOpps, appNotify, setChannelWorkflowLoadingOverlayState } from 'store/actions';
import { putWithTokenV2 } from 'api/network';

export function* updateVisibleTxnOppsSaga() {
  yield takeEvery(updateVisibleTxnOpps, function* ({ payload }) {
    const { txnOppIds, updateType } = payload;
    try {
      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: true, message: 'Loading...' }));

      yield putWithTokenV2(`/api/underwrite/workflow/tasks/${updateType}`, txnOppIds);

      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
      yield put(appNotify('Update success', 'success'));
    } catch (error) {
      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
      yield put(appNotify(error.message, 'error'));
    }
  });
}
